import blackGoldTheme from "./themes/tailwind.config.black-gold.js";
import darkPurpleTheme from "./themes/tailwind.config.dark-purple.js";
import pinkPulseTheme from "./themes/tailwind.config.pink-pulse.js";

/**
 * A collection of theme colors configurations.
 * Follow: https://www.figma.com/design/uNEH0donL2oOOuUuGPm16p/%E2%9A%AA%5BMP%5D-KZ-White-Label?node-id=10284-140837&m=dev
 */
export default {
  "dark-purple": {
    id: "dark-purple",
    name: "dark-purple",
    config: darkPurpleTheme,
  },
  "black-gold": {
    id: "black-gold",
    name: "black-gold",
    config: blackGoldTheme,
  },
  "pink-pulse": {
    id: "pink-pulse",
    name: "pink-pulse",
    config: pinkPulseTheme,
  },
};
